export default "__VITE_ASSET__DnzaiyeO__"